import SendData from '../component/sendData';
import MultipleChoiceQ from '../component/multipleChoiceQ';

function questions(userDetails){
  const MCQ1 = {
    question: "Have you ever been diagnosed or treated for any of the below conditions?",
    options: ["Diabetes", "Hypertension or High Blood Pressure", "Heart Disease", "Cancer"]
  }

  const MCQ2 = {
    question: "Do you currently have complaints about any of the following symptoms?",
    options: ["Excessive thirst", "Frequent urination", "Headaches", "Giddiness", "Chest pain", "Breathlessness", "Numbness or weakness in limbs", "Excessive weight loss in last six months", "Development of a cyst or lump", "White patches inside the mouth or white spots on the tongue", "Unusual bleeding or discharge in last six months"]
  }

  const MCQ3 = {
    question: "Does any of your immediate family members (Parent/Brother/Sister) have a history with the following health conditions?",
    options: ["Diabetes", "Hypertension or High blood pressure", "Heart disease", "Stroke", "Any type of cancer"]
  }

  return [
    {
      id: '1',
      message: 'Health Risk Assessment helps you understand your health status & suggests areas of improvement.',
      trigger: '2',
      delay: 0
    },
    {
      id: '2',
      message: 'Kindly keep your recent medical reports handy.',
      trigger: 'note',
      delay: 0
    },
    {
      id: 'note',
      message: 'The information filled in by you is confidential. Your organization will not receive any individual details.',
      trigger: 'self-family',
      delay: 0
    },
    {
      id: 'self-family',
      message: 'Are you taking this Assessment for yourself or a family member?',
      trigger: 'selfOrFamily',
      delay: 0
    },
    {
      id: 'selfOrFamily',
      options: [
        { value: 'Self', label: 'Self', trigger: 'self-general-information' },
        { value: 'Family Member', label: 'Family Member', trigger: 'family-general-information' }
      ],
    },//Self
    {
      id: 'self-general-information',
      component: <h2>Profile</h2>,
      trigger: 'selfName',
      delay: 0
    },
    {
      id: 'selfName',
      message: `Welcome, ${userDetails.displayName}!`,
      trigger: 'selfAge',
      delay: 0
    },
    {
      id: 'selfAge',
      message: 'Kindly enter your age (years).',
      trigger: 'selfAnswerAge',
      delay: 0
    },

    {
      id: 'selfAnswerAge',
      user: true,
      trigger: "selfHeight",
      validator: (value) => {
        if (isNaN(value)) {
          return 'value must be a number';
        } else if (value < 0) {
          return 'value must be positive';
        } else if (value > 120) {
          return `${value}? Come on!`;
        }
  
        return true;
      },
    },
    {
      id: 'selfHeight',
      message: 'Kindly enter your height (cm).',
      trigger: 'selfAnswerHeight',
      delay: 0
    },
    {
      id: 'selfAnswerHeight',
      user: true,
      trigger: "selfWeight",
      validator: (value) => {
        if (isNaN(value)) {
          return 'value must be a number';
        } else if (value < 0) {
          return 'value must be positive';
        }
        if(value < 12){
          return 'value must be greater than 12'
        }
        return true;
      },
    },
    {
      id: 'selfWeight',
      message: 'Kindly enter your weight (kg).',
      trigger: 'selfAnswerWeight',
      delay: 0
    },
    {
      id: 'selfAnswerWeight',
      user: true,
      trigger: "General-well-being",
      validator: (value) => {
        if (isNaN(value)) {
          return 'value must be a number';
        } else if (value < 0) {
          return 'value must be positive';
        }
        if(value < 5){
          return 'value must be greater than 5'
        }
        return true;
      },
    },
    {
      id: 'family-general-information',
      component: <h2>Profile</h2>,
      trigger: 'askName',
      delay: 0
    },
    {
      id: 'askName',
      message: 'Kindly enter your family member name',
      trigger: 'familyAnswerName',
      delay: 0
    },
    {
      id: 'familyAnswerName',
      user: true,
      trigger: 'askGender'
    },
    {
      id: 'askGender',
      message: 'Kindly enter your family member gender.',
      trigger: 'familyAnswerGender',
      delay: 0
    },
    {
      id: 'familyAnswerGender',
      options: [
        { value: 'M', label: 'Male', trigger: 'askAge' },
        { value: 'F', label: 'Female', trigger: 'askAge' },
      ],
    },
    {
      id: 'askAge',
      message: 'Kindly enter your family member age (years).',
      trigger: 'familyAnswerAge',
      delay: 0
    },
    {
      id: 'familyAnswerAge',
      user: true,
      trigger: "askHeight",
      validator: (value) => {
        if (isNaN(value)) {
          return 'value must be a number';
        } else if (value < 0) {
          return 'value must be positive';
        } else if (value > 120) {
          return `${value}? Come on!`;
        }
  
        return true;
      },
    },
    {
      id: 'askHeight',
      message: 'Kindly enter your your family member height (cm).',
      trigger: 'familyAnswerHeight',
      delay: 0
    },
    {
      id: 'familyAnswerHeight',
      user: true,
      trigger: "askWeight",
      validator: (value) => {
        if (isNaN(value)) {
          return 'value must be a number';
        } else if (value < 0) {
          return 'value must be positive';
        }
        if(value < 12){
          return 'value must be greater than 12'
        }
        return true;
      },
    },
    {
      id: 'askWeight',
      message: 'Kindly enter your family member weight (kg).',
      trigger: 'familyAnswerWeight',
      delay: 0
    },
    {
      id: 'familyAnswerWeight',
      user: true,
      trigger: "General-well-being",
      validator: (value) => {
        if (isNaN(value)) {
          return 'value must be a number';
        } else if (value < 0) {
          return 'value must be positive';
        }
        if(value < 5){
          return 'value must be greater than 5'
        }
        return true;
      },
    },
    {
      id: 'General-well-being',
      component: <h2>General Well-being</h2>,
      trigger: 'g1',
      delay: 0
    },
    {
      id: 'g1',
      message: 'How would you rate your overall health & lifestyle compared to others of your age?',
      trigger: 'healthAndLifeStyle',
      delay: 0
    },
    {
      id: 'healthAndLifeStyle',
      options: [
        { value: 'Excellent', label: 'Excellent', trigger: 'g2' },
        { value: 'Good', label: 'Good', trigger: 'g2' },
        { value: 'Average', label: 'Average', trigger: 'g2' },
        { value: 'Poor', label: 'Poor', trigger: 'g2' },
      ],
    },
    {
      id: 'g2',
      message: 'How would you rate your seriousness towards the benefits of a healthy lifestyle?',
      trigger: 'healthyLifeBenefits',
      delay: 0
    },
    {
      id: 'healthyLifeBenefits',
      options: [
        { value: 'Excellent', label: 'Excellent', trigger: 'g3' },
        { value: 'Good', label: 'Good', trigger: 'g3' },
        { value: 'Average', label: 'Average', trigger: 'g3' },
        { value: 'Poor', label: 'Poor', trigger: 'g3' },
      ],
    },
    {
      id: 'g3',
      message: 'How often do you see a physician in a year for routine check-ups, health screenings, or general disease prevention?',
      trigger: 'healthCheckUps',
      delay: 0
    },
    {
      id: 'healthCheckUps',
      options: [
        { value: 'Less than 1', label: 'Less than 1', trigger: 'g4' },
        { value: '1 to 2', label: '1 to 2', trigger: 'g4' },
        { value: '2 to 3', label: '2 to 3', trigger: 'g4' },
        { value: 'More than 3', label: 'More than 3', trigger: 'g4' },
      ],
    },
    {
      id: 'g4',
      message: 'How many days of work did you miss due to illness in the past six months?',
      trigger: 'workDaysMissed',
      delay: 0
    },
    {
      id: 'workDaysMissed',
      options: [
        { value: 'Less than 5', label: 'Less than 5', trigger: 'mcqQues1' },
        { value: '5 to 8', label: '5 to 8', trigger: 'mcqQues1' },
        { value: '8 to 12', label: '8 to 12', trigger: 'mcqQues1' },
        { value: 'More than 12', label: 'More than 12', trigger: 'mcqQues1' },
      ],
    },
    {
      id: 'mcqQues1',
      message: `${MCQ1.question}`,
      trigger: 'mcqAns1',
      delay: 0
    },
    {
      id: 'mcqAns1',
      component: <MultipleChoiceQ mcqNumber={1} mcqOptions={MCQ1.options} />,
      waitAction: true,
      trigger: 'mcqQues2',
      asMessage: true,
      delay: 0
    },
    {
      id: 'mcqQues2',
      message: `${MCQ2.question}`,
      trigger: 'mcqAns2',
      delay: 0
    },
    {
      id: 'mcqAns2',
      component: <MultipleChoiceQ mcqNumber={2} mcqOptions={MCQ2.options} />,
      waitAction: true,
      trigger: 'mcqQues3',
      asMessage: true,
      delay: 0
    },
    {
      id: 'mcqQues3',
      message: `${MCQ3.question}`,
      trigger: 'mcqAns3',
      delay: 0
    },
    {
      id: 'mcqAns3',
      component: <MultipleChoiceQ mcqNumber={3} mcqOptions={MCQ3.options} />,
      waitAction: true,
      trigger: 'physical-activity',
      asMessage: true,
      delay: 0
    },
    {
      id: 'physical-activity',
      component: <h2>Physical Activity</h2>,
      trigger: 'p1',
      delay: 0
    },
    {
      id: 'p1',
      message: 'How much time do you spend on physical activities or exercises in a week? (Brisk walking, running, climbing, etc.)',
      trigger: 'physicalActivityV2',
      delay: 0
    },
    {
      id: 'physicalActivityV2',
      options: [
        { value: 'Less than 30 mins', label: 'Less than 30 mins', trigger: 'p2' },
        { value: '30 mins to 1 hour', label: '30 mins to 1 hour', trigger: 'p2' },
        { value: '1 to 2 hours', label: '1 to 2 hours', trigger: 'p2' },
        { value: 'More than 2 hours', label: 'More than 2 hours', trigger: 'p2' },
      ],
    },
    {
      id: 'p2',
      message: 'How would you describe your energy levels throughout the day?',
      trigger: 'energyLevelsDuringDaV2',
      delay: 0
    },
    {
      id: 'energyLevelsDuringDaV2',
      options: [
        { value: 'Excellent', label: 'Excellent', trigger: 'nutrition' },
        { value: 'Good', label: 'Good', trigger: 'nutrition' },
        { value: 'Average', label: 'Average', trigger: 'nutrition' },
        { value: 'Poor', label: 'Poor', trigger: 'nutrition' },
      ],
    },
    {
      id: 'nutrition',
      component: <h2>Nutrition</h2>,
      trigger: 'n1',
      delay: 0
    },
    {
      id: 'n1',
      message: 'How would you describe your appetite or eating habits?',
      trigger: 'appetiteLevel',
      delay: 0
    },
    {
      id: 'appetiteLevel',
      options: [
        { value: 'Poor (Eating Less)', label: 'Poor (Eating Less)', trigger: 'n2' },
        { value: 'High (Overeating)', label: 'High (Overeating)', trigger: 'n2' },
        { value: 'Normal', label: 'Normal', trigger: 'n2' },
      ],
    },
    {
      id: 'n2',
      message: "How many servings of fruits & vegetables do you eat in a week?",
      trigger: "fruitsAndVeggieEatingHabbit",
      delay: 0
    },
    {
      id: 'fruitsAndVeggieEatingHabbit',
      options: [
        { value: 'Less than 1', label: 'Less than 1', trigger: 'n3' },
        { value: '1 to 2', label: '1 to 2', trigger: 'n3' },
        { value: '2 to 3', label: '2 to 3', trigger: 'n3' },
        { value: 'More than 3', label: 'More than 3', trigger: 'n3' },
      ],
    },
    {
      id: 'n3',
      message: "How often do you avoid eating foods that are high in Fats? (Milk, fried foods, fatty meats, etc.)",
      trigger: "hightFatFoodEatingHabbit",
      delay: 0
    },
    {
      id: 'hightFatFoodEatingHabbit',
      options: [
        { value: 'Always', label: 'Always', trigger: 'emotional-health' },
        { value: 'Usually', label: 'Usually', trigger: 'emotional-health' },
        { value: 'Sometimes', label: 'Sometimes', trigger: 'emotional-health' },
        { value: 'Never', label: 'Never', trigger: 'emotional-health' },
      ],
    },
    {
      id: 'emotional-health',
      component: <h2>Emotional Health</h2>,
      trigger: 'e1',
      delay: 0
    },
    {
      id: 'e1',
      message: 'How often did you feel restless, indifferent, depressed, or distracted in the last month?',
      trigger: 'stress',
      delay: 0
    },
    {
      id: 'stress',
      options: [
        { value: 'Always', label: 'Always', trigger: 'e2' },
        { value: 'Usually', label: 'Usually', trigger: 'e2' },
        { value: 'Sometimes', label: 'Sometimes', trigger: 'e2' },
        { value: 'Never', label: 'Never', trigger: 'e2' },
      ],
    },
    {
      id: 'e2',
      message: 'How many hours do you sleep daily?',
      trigger: 'SleepPattern',
      delay: 0
    },
    {
      id: 'SleepPattern',
      options: [
        { value: 'Less than 6 hours', label: 'Less than 6 hours', trigger: 'habits' },
        { value: '6 to 8 hours', label: '6 to 8 hours', trigger: 'habits' },
        { value: '8 to 10 hours', label: '8 to 10 hours', trigger: 'habits' },
        { value: 'More than 10 hours', label: 'More than 10 hours', trigger: 'habits' },
      ],
    },
    {
      id: 'habits',
      component: <h2>Habits</h2>,
      trigger: 'h1',
      delay: 0
    },
    {
      id: 'h1',
      message: 'How often do you consume tobacco products? (Cigarettes, smokeless tobacco, cigars, pipes, etc.)',
      trigger: 'tobaccoConsumption',
      delay: 0
    },
    {
      id: 'tobaccoConsumption',
      options: [
        { value: 'Regularly', label: 'Regularly', trigger: 'h2' },
        { value: 'Usually', label: 'Usually', trigger: 'h2' },
        { value: 'Sometimes', label: 'Sometimes', trigger: 'h2' },
        { value: 'Never', label: 'Never', trigger: 'h2' },
      ],
    },
    {
      id: 'h2',
      message: 'How often do you consume alcohol products? (Beer, liquor, wine, etc.)',
      trigger: 'alchoholConsumption',
      delay: 0
    },
    {
      id: 'alchoholConsumption',
      options: [
        { value: 'Regularly', label: 'Regularly', trigger: 'health-screening' },
        { value: 'Usually', label: 'Usually', trigger: 'health-screening' },
        { value: 'Sometimes', label: 'Sometimes', trigger: 'health-screening' },
        { value: 'Never', label: 'Never', trigger: 'health-screening' },
      ],
    },
    {
      id: 'health-screening',
      component: <h2>Health Screening</h2>,
      trigger: 'hs2',
      delay: 0
    },
    {
      id: 'hs2',
      message: 'What was your Blood pressure level?',
      trigger: 'BPRating',
      delay: 0
    },
    {
      id: 'BPRating',
      options: [
        { value: 'Normal', label: 'Normal', trigger: 'hs3' },
        { value: 'High', label: 'High', trigger: 'hs3' },
        { value: 'Low', label: 'Low', trigger: 'hs3' },
        { value: "Dont know", label: "Don't know", trigger: 'hs3' },
      ],
    },
    {
      id: 'hs3',
      message: 'How was your ECG (Electrocardiogram) result?',
      trigger: 'ECGReport',
      delay: 0
    },
    {
      id: 'ECGReport',
      options: [
        { value: 'Normal', label: 'Normal', trigger: 'hs5' },
        { value: 'Unusual', label: 'Unusual', trigger: 'hs5' },
        { value: "Dont know", label: "Don't know", trigger: 'hs5' },
      ],
    },
    {
      id: 'hs5',
      message: 'How was your TMT (Treadmill Test) result?',
      trigger: 'TMTReport',
      delay: 0
    },
    {
      id: 'TMTReport',
      options: [
        { value: 'Normal', label: 'Normal', trigger: 'hs6' },
        { value: 'Unusual', label: 'Unusual', trigger: 'hs6' },
        { value: "Dont know", label: "Don't know", trigger: 'hs6' },
      ],
    },
    {
      id: 'hs6',
      message: 'What was your Cholesterol level?',
      trigger: 'TotalCholesterol',
      delay: 0
    },
    {
      id: 'TotalCholesterol',
      options: [
        { value: 'Less than 200', label: 'Less than 200', trigger: 'hs7' },
        { value: '200 to 300', label: '200 to 300', trigger: 'hs7' },
        { value: 'More than 300', label: 'More than 300', trigger: 'hs7' },
        { value: "Dont know", label: "Don't know", trigger: 'hs7' },
      ],
    },
    {
      id: 'hs7',
      message: 'What was your Blood Sugar level?',
      trigger: 'BloodSugarLevel',
      delay: 0
    },
    {
      id: 'BloodSugarLevel',
      options: [
        { value: 'Less than 100', label: 'Less than 100', trigger: 'hs8' },
        { value: '100 to 200', label: '100 to 200', trigger: 'hs8' },
        { value: 'More than 200', label: 'More than 200', trigger: 'hs8' },
        { value: "Dont know", label: "Don't know", trigger: 'hs8' },
      ],
    },
    {
      id: 'hs8',
      message: 'What was your HbA1C (Glycated hemoglobin) level?',
      trigger: 'HbA1C',
      delay: 0
    },
    {
      id: 'HbA1C',
      options: [
        { value: 'Less than 6', label: 'Less than 6', trigger: 'send-data' },
        { value: '6 to 8', label: '6 to 8', trigger: 'send-data' },
        { value: 'More than 8', label: 'More than 8', trigger: 'send-data' },
        { value: "Dont know", label: "Don't know", trigger: 'send-data' },
      ],
    },
    {
      id: 'send-data',
      component: <SendData />,
      trigger: "40",
      delay: 0
    },
    {
      id: '40',
      message: `Congratulations on completing your Health Risk Assessment, the first step towards Wellness!`,
      delay: 0,
      trigger: '41'
    },
    {
      id: '41',
      message: `A Personalized Report will be shared with your registered Email ID (${userDetails.email})`,
      end: true,
      delay: 0
    }
  ]
}

export default questions